import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getMaintenanceBasic } from '../Api'

export default generateApiAction({
  baseType: Types.MAINTENANCES.GET.BASIC,
  api: getMaintenanceBasic,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/maintenances/GetBasicAction.js